/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Earliest allowed UTC start time for slots of this event kind (e.g., 09:00)
 */
export type EventKindAllowedTimeStart = string | null;
